export const DNT_STORAGE_NAME = 'x-dnt';
